import React from "react";
import ConfirmDialog from "components/ui/confirm-dialog";

/**
 * Adapter over the shared `components/ui/confirm-dialog`.
 *
 * Was a second hand-built portal dialog with the same shortcomings as the
 * `support/` copy. Props preserved for existing call sites (TemplateGrid).
 */

export interface TemplatesConfirmationDialogProps {
    isOpen: boolean;
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    confirmVariant?: "danger" | "primary";
    isLoading?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmationDialog: React.FC<TemplatesConfirmationDialogProps> = ({
    isOpen,
    title,
    message,
    confirmText = "Confirm",
    cancelText = "Cancel",
    confirmVariant = "primary",
    isLoading = false,
    onConfirm,
    onCancel,
}) => (
    <ConfirmDialog
        open={isOpen}
        title={title}
        description={message}
        tone={confirmVariant === "danger" ? "danger" : "brand"}
        confirmLabel={confirmText}
        cancelLabel={cancelText}
        isLoading={isLoading}
        onConfirm={onConfirm}
        onCancel={onCancel}
    />
);

export default ConfirmationDialog;
